import { createContext } from 'react';
import utils from 'utils';
import { AuthBody, LoginValues, TwoFactorLoginValues } from 'models/AuthBody';

type AuthContextValues = {
  isLoggedIn: boolean;
  logoutRequest: () => void;
  loginRequest: (
    values: LoginValues,
    onSuccess?: (data: AuthBody) => void,
  ) => Promise<void>;
  twoFactorLoginRequest: (
    values: TwoFactorLoginValues,
    onSuccess?: (data: AuthBody) => void,
  ) => Promise<void>;
  onLoginReq: (values: AuthBody) => Promise<void>;
  forgotPasswordRequest: (
    email: string,
    onSuccess?: () => void,
  ) => Promise<void>;
  resetPasswordRequest: (
    newPassword: string,
    token: string,
    onSuccess?: () => void,
  ) => Promise<void>;
  getToken: () => string | null;
};

export default createContext<AuthContextValues>({
  isLoggedIn: false,
  logoutRequest: utils.noop,
  loginRequest: utils.noop,
  twoFactorLoginRequest: utils.noop,
  onLoginReq: utils.noop,
  resetPasswordRequest: utils.noop,
  forgotPasswordRequest: utils.noop,
  getToken: utils.noop,
});
